import React from 'react';
export const OSM_ATTRIBUTION = {text:'© OpenStreetMap contributors',url:'https://www.openstreetmap.org/copyright'};
// Visibilidad centralizada para los avisos añadidos por la plataforma.
export function isAttributionVisible(attribution) {
  return Boolean(attribution?.text) && attribution.url !== OSM_ATTRIBUTION.url && !/OpenStreetMap/i.test(attribution.text);
}
export default function Attribution({attribution}) {
  if(!isAttributionVisible(attribution)) return null;
  const url = ['https://www.openstreetmap.org/copyright','https://maps.google.com'].includes(attribution.url) ? attribution.url : null;
  return <small style={{display:'block',marginTop:4}}>{url ? <a href={url} target="_blank" rel="noopener noreferrer">{attribution.text}</a> : attribution.text}</small>;
}
